export enum ButtonColor {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
}

export enum ButtonStatus {
  NOT_STARTED = "not_started",
  COMPLETED = "completed",
  FAILED = "failed",
  WINNER = "winner",
}

interface IButtonColorConfig {
  backgroundColor: string;
  textColor: string;
  hoverBackgroundColor: string;
  hoverTextColor: string;
  textOpacity?: number;
  hoverTextOpacity?: number;
}
type TButtonColor = "primary" | "secondary" | "tertiary";
export const buttonColorConfig: Record<TButtonColor, IButtonColorConfig> = {
  primary: {
    backgroundColor: "common.white",
    textColor: "common.black",
    hoverBackgroundColor: "dsPrimary.v300",
    hoverTextColor: "common.white",
  },
  /**
   * In Figma, secondary is tertiary and vice versa. The secondary design does not have a
   * good looking mapping between dark and light mode wrt the dsSurface palette, so we'll just
   * use tertiary for now and call it secondary in the app.
   */
  secondary: {
    backgroundColor: "dsSurface.v200",
    textColor: "dsBase.v200",
    hoverBackgroundColor: "dsSurface.v300",
    hoverTextColor: "dsBase.v200",
  },
  tertiary: {
    backgroundColor: "dsSurface.v100",
    textColor: "dsBase.v200",
    textOpacity: 0.4,
    hoverBackgroundColor: "common.white",
    hoverTextColor: "common.black",
    hoverTextOpacity: 1,
  },
};

export type ButtonShape = "default" | "pill";

interface IButtonSizeConfig {
  textVariant: string;
  padding: string;
  borderRadius: string;
  pillBorderRadius: string;
}

type ButtonSize = "small" | "medium" | "large";
export const buttonSizeConfig: Record<ButtonSize, IButtonSizeConfig> = {
  small: {
    textVariant: "textBase500",
    padding: "12px 20px",
    borderRadius: "8px",
    pillBorderRadius: "100px",
  },
  medium: {
    textVariant: "text1xl600",
    padding: "16px 28px",
    borderRadius: "12px",
    pillBorderRadius: "100px",
  },
  large: {
    textVariant: "text1xl600",
    padding: "16px 28px",
    borderRadius: "12px",
    pillBorderRadius: "100px",
  },
};

export const circularProgressSizeConfig = {
  small: 20,
  medium: 20,
  large: 24,
};

export const buttonStatusConfig = {
  not_started: {
    backgroundColor: "dsSurface.v100",
    color: "dsNeutral.v400",
  },
  completed: {
    backgroundColor: "dsSuccess.v200",
    color: "dsSuccess.v400",
  },
  failed: {
    backgroundColor: "dsDestructive.v100",
    color: "dsDestructive.v400",
  },
  winner: {
    backgroundColor: "dsWarning.v100",
    color: "dsWarning.v300",
  },
};
